import { render, staticRenderFns } from "./ModalDropdown.vue?vue&type=template&id=54478a5e&scoped=true&"
import script from "./ModalDropdown.vue?vue&type=script&lang=js&"
export * from "./ModalDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ModalDropdown.vue?vue&type=style&index=0&id=54478a5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54478a5e",
  null
  
)

export default component.exports